<template>
  <div class="main-title-box">
    <h1>{{ title }}</h1>
  </div>
</template>
<script>
export default {
  props: ["title"]
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.main-title-box {
  width: 100%;
  text-align: center;
  padding: 20px 0px;
  background-color: $background-main;
  h1 {
    text-transform: uppercase;
    color: $text-clear-3;
  }
}
</style>
